/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To keep the separation equivalent. A smaller column needs proportionally less flow, injection and gradient time to reproduce the original chromatography.`)
};

const es_hplc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para mantener la separación equivalente. Una columna más pequeña necesita proporcionalmente menos flujo, inyección y tiempo de gradiente para reproducir la cromatografía original.`)
};

const de_hplc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um die Trennung gleichwertig zu halten. Eine kleinere Säule benötigt proportional weniger Fluss, Injektion und Gradientenzeit, um die ursprüngliche Chromatographie zu reproduzieren.`)
};

const nl_hplc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om de scheiding gelijkwaardig te houden. Een kleinere kolom heeft evenredig minder flow, injectie en gradiënttijd nodig om de oorspronkelijke chromatografie te reproduceren.`)
};

const fr_hplc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour conserver une séparation équivalente. Une colonne plus petite nécessite proportionnellement moins de débit, d'injection et de temps de gradient pour reproduire la chromatographie d'origine.`)
};

const it_hplc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per mantenere la separazione equivalente. Una colonna più piccola richiede flusso, iniezione e tempo di gradiente proporzionalmente minori per riprodurre la cromatografia originale.`)
};

const pt_br2_hplc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para manter a separação equivalente. Uma coluna menor precisa proporcionalmente de menos fluxo, injeção e tempo de gradiente para reproduzir a cromatografia original.`)
};

const pt_hplc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para manter a separação equivalente. Uma coluna mais pequena precisa de caudal, injeção e tempo de gradiente proporcionalmente menores para reproduzir a cromatografia original.`)
};

const ja_hplc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分離能を同等に保つためです。小さいカラムでは、元のクロマトグラフィーを再現するために流速、注入量、グラジエント時間を比例して減らす必要があります。`)
};

const zh_hplc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为了保持分离效果等效。较小的色谱柱需要按比例减少流速、进样量和梯度时间，才能重现原有的色谱分离效果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_faq_a1", locale)
	if (locale === "en") return en_hplc_faq_a1(inputs)
	if (locale === "es") return es_hplc_faq_a1(inputs)
	if (locale === "de") return de_hplc_faq_a1(inputs)
	if (locale === "nl") return nl_hplc_faq_a1(inputs)
	if (locale === "fr") return fr_hplc_faq_a1(inputs)
	if (locale === "it") return it_hplc_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_faq_a1(inputs)
	if (locale === "pt") return pt_hplc_faq_a1(inputs)
	if (locale === "ja") return ja_hplc_faq_a1(inputs)
	return zh_hplc_faq_a1(inputs)
};